import { map, Observable } from 'rxjs';

// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountWidgetDto, ScheduledMaintenanceDto } from '@ellf/common-dto';
import { FieldConfig, FilterValue } from '@ellf/common-interfaces';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class ScheduledMaintenanceApiClient extends BaseCRUDApiClient<ScheduledMaintenanceDto> {
  baseUrl = this.config.apiEndpoint + '/scheduled-maintenance';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  getCountInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<CountWidgetDto>(
      `${this.baseUrl}/get-count-in-period`,
      {
        fromDate,
        toDate,
        ...filters,
      },
    );
  }

  getIITInPeriod(
    fromDate: string | undefined,
    toDate: string | undefined,
    filters: any,
  ) {
    return this.http.post<any>(`${this.baseUrl}/get-iit-in-period`, {
      fromDate,
      toDate,
      ...filters,
    });
  }

  override downloadExcel(
    fileName?: string | undefined,
    columns?: FieldConfig[] | undefined,
    filters?: FilterValue[] | undefined,
    orderBy?: { [field: string]: 'asc' | 'desc' } | undefined,
    join?: string[] | undefined,
    calendar?: any,
  ): Observable<ArrayBuffer> {
    const mappedFilters = this.mapFilters(filters);

    return super.downloadExcel(
      fileName,
      columns,
      mappedFilters || [],
      orderBy,
      join,
      calendar === true ? '/download-calendar-excel' : '/download-excel',
    );
  }

  findAllFiltered(
    filters: FilterValue[],
    orderBy: { [field: string]: 'asc' | 'desc' },
    join?: string[],
    overwriteJoin?: boolean,
  ) {
    return this.http.post<ScheduledMaintenanceDto[]>(
      `${this.baseUrl}/find-all-filtered`,
      {
        filters,
        orderBy,
        join,
        overwriteJoin,
      },
    );
  }

  downloadTimeschedule(
    fileName?: string,
    columns?: FieldConfig[],
    filters?: FilterValue[],
    orderBy?: { [field: string]: 'asc' | 'desc' },
    join?: string[],
  ) {
    return this.http.post<ScheduledMaintenanceDto[]>(
      `${this.baseUrl}/download-timeschedule`,
      { fileName, columns, filters: filters || [], orderBy, join },
    );
  }

  downloadClosedMaintenancesModelExcel(
    fileName?: string,
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-closed-maintenances-model-excel',
        { fileName },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  uploadClosedMaintenancesFromExcel(list: FileList) {
    const files = Array.from(list);
    const fd = new FormData();
    files.forEach((file) => fd.append('files', file));
    return this.http.post<
      { errors: { error: string; row: number | undefined }[] }[]
    >(this.baseUrl + '/upload-closed-maintenances-from-excel', fd);
  }
}
